import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
var isClient = typeof window !== "undefined";

var Responsive = /*#__PURE__*/function (_React$Component) {
  _inherits(Responsive, _React$Component);

  var _super = _createSuper(Responsive);

  function Responsive() {
    var _this;

    _classCallCheck(this, Responsive);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      height: isClient ? window.innerHeight : 0,
      width: isClient ? window.innerWidth : 0
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      window.addEventListener("resize", _this.onResize);

      _this.setState({
        height: window.innerHeight,
        width: window.innerWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener("resize", _this.onResize);
    });

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      _this.setState(function () {
        return {
          height: window.innerHeight,
          width: window.innerWidth
        };
      });
    });

    return _this;
  }

  _createClass(Responsive, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["children"]);

      var minWidth = props.minWidth,
          maxWidth = props.maxWidth;
      var width = this.state.width;
      var shouldRender = width > minWidth && width < maxWidth;
      return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRender && children);
    }
  }]);

  return Responsive;
}(React.Component);

_defineProperty(Responsive, "defaultProps", {
  winWidth: 0,
  maxWidth: 99999
});

export default Responsive;